<osp-notification-overlay-toggler
  (onClick)="overlayPanel.toggle($event)"
  [icon]="IconKey.TopbarNotificationIndicator | icon"
  [amount]="notificationsTotalAmount$ | async"
/>

<osp-overlay-panel #op [showFooter]="false">
  <div class="text-overflow" header>
    <h3>
      {{ (notificationsTotalAmount$ | async) ?? '' }}
      {{ 'modules.navigation.sidebar.notifications' | translate }}
    </h3>
  </div>

  <div body>
    @if ((notificationsTotalAmount$ | async)! > 0) {
      @for (notification of notifications$ | async; track notification.alarmId) {
        <osp-overlay-notification>
          <div class="notification__left-column" (click)="onItemClick(notification.navigateUrl!)">
            <osp-notification-severity-ball
              [severity]="notification.alarmLevel | alarmLevelToNotificationBallSeverity"
            />
            <div class="notification__info">
              <p class="text-overflow text-sm text-color font-bold">
                {{ notification.alarmType | alarmTypeDisplay }}
              </p>
              <p class="text-overflow text-xs text-color">{{ notification.title }}</p>
              <p class="text-overflow text-xs text-500">{{ notification.message }}</p>
            </div>
          </div>
          <div class="notification__right-column">
            @if (!notification.shouldHideDefaultAcknowledgeButton) {
              <osp-acknowledge-notification-button (onClick)="acknowledgeAlarm(notification.alarmId)" />
            }
          </div>
        </osp-overlay-notification>
      }
    } @else {
      <osp-overlay-notification>
        <p class="text-sm text-color m-0">{{ 'revolution.modules.notification.noNotificationFound' | translate }}</p>
      </osp-overlay-notification>
    }
  </div>
</osp-overlay-panel>
